import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
} from '@angular/core';
import { setCssProperty } from '../../../cross-team-shared/misc-utils';
import { Point2D } from '../../../team-apis/otterdam/answers/shape-typings';

export interface SubpointInfo {
  subpointIndex: number;
  point: Point2D;
  selected: boolean;
  hidden?: boolean;
  cursor?: string;
  renderAsDiamond?: boolean;
  overrideColor?: string;
}

// This will eventually be a reference to a color in the shared UI library
const SELECTION_COLOR = '#fffa09';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector -- svg needs attribute selectors
  selector: '[h3Subpoint]',
  templateUrl: './subpoint.component.html',
  styleUrls: ['./subpoint.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SubpointComponent implements OnChanges {
  @Input('h3Subpoint') subpointInfo!: SubpointInfo;
  @Input() shapeSelected = false;

  constructor(private elementRef: ElementRef) {}

  ngOnChanges() {
    setCssProperty(
      this.elementRef,
      '--h3-subpoint-cursor',
      this.subpointInfo.cursor,
    );

    let color = this.subpointInfo.overrideColor;
    if (this.shapeSelected && !this.subpointInfo.overrideColor) {
      color = SELECTION_COLOR;
    }
    setCssProperty(this.elementRef, '--h3-shape-color', color);
  }
}
